import { render, staticRenderFns } from "./EditTaskStatusModal.vue?vue&type=template&id=bc9c73fc&scoped=true&"
import script from "./EditTaskStatusModal.vue?vue&type=script&lang=js&"
export * from "./EditTaskStatusModal.vue?vue&type=script&lang=js&"
import style0 from "./EditTaskStatusModal.vue?vue&type=style&index=0&id=bc9c73fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9c73fc",
  null
  
)

export default component.exports